import { assert } from '@ember/debug';

/**
 * Reverses a whole-number percentage (70 means 70%, not 0.7) in the input’s units; zero percent
 * returns zero.
 * @throws a development assertion for a non-integer percentage or one outside 0–100
 */
export default function calculatePrePercentageValue(
  postPercentageValue: number,
  percentage: number
): number {
  if (!Number.isInteger(percentage) || percentage < 0 || percentage > 100) {
    assert('Percentage must be a whole number between 0 and 100.');
  }

  // Zero percent has no recoverable original value; use zero instead of division by zero.
  if (percentage === 0) {
    return 0;
  }

  const decimalPercentage = percentage / 100;

  const prePercentageValue = postPercentageValue / decimalPercentage;

  return prePercentageValue;
}
